module.exports = __webpack_public_path__ + "img/Hochbeete_2.e0fb40a.png";